import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";
import { startOfDay, endOfDay, addDays } from "date-fns";

async function getClientCampaings(advertiserId) {
    try {
        const token = getToken();

        const begin_of_day = startOfDay(new Date());
        const end_of_day = endOfDay(new Date());
    
        // Fallback to the last 30 days if nothing is stored in cookies
        const defaultCurrentPeriod = [
            addDays(begin_of_day, -29),
            end_of_day,
        ];
        
        const response = await axiosInstance.post(`/api/analytics/campaign/period/client-campaigns?advertiserId=${advertiserId}`, {
            current_period: defaultCurrentPeriod
        }, {
            headers: {
            'Authorization': token
            }
        });

        return response?.data;
    } catch (error) {
        console.log(error);
        throw error; // Re-throw the error for further handling if needed
    }
}

export default getClientCampaings;
